import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import _ from "lodash"

import En from "./en"
import Ar from "./ar"

// the translations
const resources = {
  en: {
    translation: En,
  },
  ar: {
    translation: Ar,
  },
}

export let isLangEn = () => i18n.language == 'en' 
export let getDir = () => i18n.language == 'en'? 'ltr' : 'rtl'

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: localStorage.getItem('lang') ?? 'en' ,
    // keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    react: {
      wait: true,
    },
  })

export default i18n
